import { AfterViewInit, Directive, Input, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'mat-checkbox[control]',
  exportAs: 'checkboxValue',
  standalone: false,
})
export class CheckboxValueDirective implements AfterViewInit {
  private checkbox = inject(MatCheckbox);

  @Input() control?: FormControl;

  @Input() falseValue: any = '0';

  @Input() trueValue: any = '1';

  ngAfterViewInit() {
    this.control?.setValue(this.checkbox?.checked ? this.trueValue : this.falseValue);
    this.checkbox?.registerOnChange(() => {
      this.control?.setValue(this.checkbox?.checked ? this.trueValue : this.falseValue);
    });
  }
}
